/** @jsxImportSource @emotion/react */
import { Link } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import { FormButton } from '../../components/Form/css'
import Helmet from '../../components/Helmet'
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

const ComingSoon = () => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 60vh;
        padding: 32px;
      `}
    >
      <Helmet title='Coming Soon' />
      <h3
        css={css`
          font-size: 24px;
          font-weight: 600;
          color: ${colors.NEUTRAL_0};
          margin-bottom: 16px;
          text-align: center;
        `}
      >
        This feature is coming soon
      </h3>
      <p
        css={css`
          font-size: 16px;
          color: ${colors.NEUTRAL_100};
          margin-bottom: 32px;
          text-align: center;
        `}
      >
        We&apos;re working hard to bring you this feature. Check back soon!
      </p>
      <Link to={ROUTES.HOME_ROOT}>
        <FormButton
          css={css`
            display: flex;
            width: auto;
            margin: 0 auto;
          `}
        >
          Go Home
        </FormButton>
      </Link>
    </div>
  )
}

export default ComingSoon
